import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Label,
  FormFeedback,
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  ModalFooter,
  Spinner,
  OffcanvasBody,
  Offcanvas,
  OffcanvasHeader,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import CustomerTypeService from "../../../services/OrderingServices/CustomerTypeService";

// Validation Schema
const validationSchema = Yup.object({
  // username: Yup.string().required("Username is required"),
  name: Yup.string().required("Customer type is required"),
  description: Yup.string().required("Description is required"),

  discountPercentage: Yup.string().required(
    "Discount percentage is required (Only Number)"
  ),
  isActive: Yup.boolean(),

  // password: Yup.string()
  //   .min(6, "Password must be at least 6 characters")
  //   .matches(
  //     /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
  //     "Password must contain at least one uppercase, one lowercase, and one number"
  //   )
  //   .required("Password is required"),
});

const CustomerTypeForm = ({ selectedUnit, modal, toggleModal, fetchUnit }) => {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: selectedUnit?.id || "",

      // username: selectedUnit?.username || "",
      name: selectedUnit?.name || "",
      description: selectedUnit?.description || "",
      discountPercentage: selectedUnit?.discountPercentage || "",
      isActive: selectedUnit?.isActive ?? true,
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);

        if (values.id) {
          await CustomerTypeService.update(values);
          toast.success("Customer type updated successfully.");
        } else {
          await CustomerTypeService.create(values);
          toast.success("New customer type is added successfully");
          resetForm();
        }
        fetchUnit();
        toggleModal();
      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data);
      } finally {
        setLoading(false);
      }
    },
  });
  // Reset form when modal closes
  useEffect(() => {
    if (!modal) {
      formik.resetForm();
    }
  }, [modal]);
  return (
    <Offcanvas
      isOpen={modal}
      toggle={toggleModal}
      direction="end"
      backdrop={true}
      scrollable
      style={{ width: "420px" }}
    >
      {/* HEADER */}
      <OffcanvasHeader toggle={toggleModal} className="border-bottom">
        <i className="ri-stack-line me-2"></i> Customer Type Form
      </OffcanvasHeader>

      {/* WRAPPER FORM */}
      <Form
        onSubmit={formik.handleSubmit}
        className="d-flex flex-column flex-grow-1"
      >
        <OffcanvasBody className="d-flex flex-column p-3">
          {/* SCROLLABLE CONTENT */}
          <div className="flex-grow-1 overflow-auto">
            {/* Name */}
            <div className="mb-3">
              <Label className="fw-bold mb-2">Customer Type</Label>
              <Input
                id="name"
                name="name"
                type="text"
                className="form-control shadow-sm"
                placeholder="Enter customer type"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
                invalid={!!(formik.touched.name && formik.errors.name)}
              />
              {formik.touched.name && formik.errors.name && (
                <FormFeedback type="invalid">{formik.errors.name}</FormFeedback>
              )}
            </div>
            {/* Discount Percentage */}
            <div className="mb-3">
              <Label className="fw-bold mb-2">Discount Percentage</Label>
              <Input
                id="discountPercentage"
                name="discountPercentage"
                type="text"
                className="form-control shadow-sm"
                placeholder="Enter discount percentage"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.discountPercentage}
                invalid={
                  !!(
                    formik.touched.discountPercentage &&
                    formik.errors.discountPercentage
                  )
                }
              />
              {formik.touched.discountPercentage &&
                formik.errors.discountPercentage && (
                  <FormFeedback type="invalid">
                    {formik.errors.discountPercentage}
                  </FormFeedback>
                )}
            </div>
            {/* Description */}
            <div className="mb-3">
              <Label className="fw-bold mb-2">Description</Label>
              <textarea
                id="description"
                name="description"
                rows={5}
                className={`form-control shadow-sm ${
                  formik.touched.description && formik.errors.description
                    ? "is-invalid"
                    : ""
                }`}
                placeholder="Enter description"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.description}
                style={{ padding: "1rem" }}
              />
              {formik.touched.description && formik.errors.description && (
                <div className="invalid-feedback">
                  {formik.errors.description}
                </div>
              )}
            </div>{" "}
            {/* Active Status Toggle */}
            <div className="mb-3 d-flex align-items-center justify-content-between">
              <Label className="fw-bold mb-0">Active Status</Label>
              <div className="form-check form-switch">
                <Input
                  type="switch"
                  id="isActive"
                  name="isActive"
                  className="form-check-input"
                  checked={formik.values.isActive}
                  onChange={formik.handleChange}
                />
              </div>
            </div>
          </div>

          {/* FOOTER BUTTONS (Sticky) */}
          <div
            className="bg-white border-top pt-3 pb-3 d-flex justify-content-between gap-2 position-sticky"
            style={{ bottom: 0, left: 0 }}
          >
            <Button
              color="danger"
              onClick={toggleModal}
              className="w-50 border shadow-sm"
            >
              Cancel
            </Button>

            <Button
              color="primary"
              type="submit"
              className="w-50 shadow-sm"
              disabled={loading}
            >
              {loading && <Spinner size="sm" className="me-2" />}
              {loading
                ? selectedUnit?.id
                  ? "Updating..."
                  : "Creating..."
                : selectedUnit?.id
                ? "Update"
                : "Create"}
            </Button>
          </div>
        </OffcanvasBody>
      </Form>
    </Offcanvas>
  );
};

export default CustomerTypeForm;
